<div class="true-stories-container">
  <div class="header">
    <button class="back-button" onclick="window.history.back()">&#x2190;</button>
    <h1>True Stories</h1>
  </div>

  <div *ngIf="loading" class="loading-indicator">
    <p>Loading stories...</p>
  </div>

  <div *ngIf="error" class="error-message">
    <p>{{ error }}</p>
  </div>

  <div *ngIf="!loading && !error" class="stories-list">
    <div *ngFor="let item of stories" class="story-card">
      <img [src]="baseUrl + item.field_cover_image" alt="Story image" class="story-image">
      <div class="story-content">
        <h2>{{ item.title }}</h2>
        <p>{{ item.field_short_description }}</p>
      </div>
      <div class="item-age">15+</div>
    </div>
  </div>
</div>
